import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const ChecklistAssign = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/employee/resignation/checklistassign/${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const getResignationId = (id, token) => {
  //   let qs = buildQuery(query);
  let url = `${baseUrl}/employee/resignation/checklistbyID/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const ktSubmit = (data, token) =>
  axios.post(`${baseUrl}/employee/resignation/checklistassign`, data, {
    headers: {
      authorization: token,
    },
  });
export const getCheckInitiatedFormDataById = (id, token) => {
  //   let qs = buildQuery(query);
  let url = `${baseUrl}/employee/resignation/checklistupdatedbyID/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getCheckListForEmp = (token) => {
  return axios.get(`${baseUrl}/employee/resignation/checklistForEmp`, {
    headers: {
      authorization: token,
    },
  });
};
export const checkListDocSubmit = (data, token) =>
  axios.post(`${baseUrl}/employee/resignation/checklistdocsubmit`, data, {
    headers: {
      authorization: token,
    },
  });

export const empChecklistSubmit = (data, token) =>
  axios.patch(`${baseUrl}/employee/resignation/checklistsubmit`, data, {
    headers: {
      authorization: token,
    },
  });

export const getCheckListForRm = (token) => {
  return axios.get(`${baseUrl}/employee/resignation/checklistForRM`, {
    headers: {
      authorization: token,
    },
  });
};
export const credentialChecklist = (data, token) => {
  return axios.post(
    `${baseUrl}/employee/resignation/CredentialschecklistApprove`,
    data,
    {
      headers: {
        authorization: token,
      },
    }
  );
};
export const getCheckListForRmById = (id, token) => {
  //   let qs = buildQuery(query);
  let url = `${baseUrl}/employee/resignation/checklistDetailsByIDForRM/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getEmpDocument = (id, token) => {
  let url = `${baseUrl}/employee/resignation/DownloadKTDocument/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
};

export const postKTchecklistApprove = (token, data) => {
  //   let qs = buildQuery(query);
  let url = `${baseUrl}/employee/resignation/KTchecklistApprove`;
  return axios.patch(url, data, {
    headers: {
      authorization: token,
    },
  });
};

export const getAssetsCheckList = (query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/employee/resignation/AssetsChecklist/${qs}`, {
    headers: {
      authorization: token,
    },
  });
};

export const getAssetsCheckListDetailById = (id, token) => {
  return axios.get(`${baseUrl}/employee/resignation/AssetsDetailsbyId/${id}`, {
    headers: {
      authorization: token,
    },
  });
};
export const assestChecklistApprove = (data, token) => {
  return axios.post(
    `${baseUrl}/employee/resignation/AssetsChecklistApprove`,
    data,
    {
      headers: {
        authorization: token,
      },
    }
  );
};

export const AssetsChecklistApproveByID = (id, token) => {
  return axios.get(`${baseUrl}/employee/resignation/AssetsDetailedbyId/${id}`, {
    headers: {
      authorization: token,
    },
  });
};

export const credentialChecklistByID = (id, token) => {
  return axios.get(
    `${baseUrl}/employee/resignation/CredentialschecklistDetails/${id}`,
    {
      headers: {
        authorization: token,
      },
    }
  );
};

export const FnfProcessChecklist = (query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/employee/resignation/ExitChecklist${qs}`, {
    headers: {
      authorization: token,
    },
  });
};

export const FnfProcessChecklistSubmit = (data, id, token) => {
  return axios.patch(
    `${baseUrl}/employee/resignation/ExitChecklistSubmit/${id}`,
    data,
    {
      headers: {
        authorization: token,
      },
    }
  );
};

export const FnfProcessChecklistById = (id, token) => {
  return axios.get(
    `${baseUrl}/employee/resignation/ExitChecklistDetails/${id}`,
    {
      headers: {
        authorization: token,
      },
    }
  );
};
//stage update//

export const getStageUpdate = (data, token) => {
  return axios.post(`${baseUrl}/employee/resignation/stageupdate`, data, {
    headers: {
      authorization: token,
    },
  });
};
